/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de clientes.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmClientes from "../../../catalogos/clientes/FrmClientes.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmClientesPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmClientes">
      <FrmClientes />
    </SizeSoftXFrmPortatil>
  );
}
